<h2 mat-dialog-title>{{ actionTitle }}</h2>

<mat-dialog-content class="confirm">
    <mat-dialog-content class="entity-obj" [innerHTML]="dialogContent"> </mat-dialog-content>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="" i18n="@@SHARED.BTN.CANCEL" (click)="cancelClicked.emit()">Cancel</button>
    <button
        *ngIf="isSaveIncluded"
        mat-raised-button
        color="primary"
        class="new-primary-button"
        [mat-dialog-close]="confirmationActionData"
        (click)="saveClicked.emit(data)"
    >
        {{ saveActionText }}
    </button>
</mat-dialog-actions>
